import ColorInsightTags from "@/components/tags/ColorInsightTags";
import { Resource } from "../../../types";

interface ResourceCellProps {
  resources: Resource[];
}

export const ResourceCell = ({ resources }: ResourceCellProps) => {
  const resourceNames = resources
    .map(r => r.resource_name)
    .filter((name): name is string => Boolean(name));

  return (
    <div className="al-px-2">
      <ColorInsightTags tags={resourceNames} showMore />
    </div>
  );
};
